import { useCallback, useEffect, useMemo, useState } from "react";
import { IconButton, Tooltip } from "@mzc-pdc/ui";
import { IconClose, IconReply } from "@mzc-cloudplex/icons";
import { useTranslation } from "react-i18next";
import useCheckPermission from "@hooks/useCheckPermission";
import { useLocation } from "react-router-dom";

const useFoldActionButtons = ({ type, defaultValue, hidden }) => {
    const { t } = useTranslation();
    const location = useLocation();

    const [active, setActive] = useState(false);

    useEffect(() => {
        if (defaultValue !== undefined) {
            if (!hidden) {
                setActive(defaultValue);
            }
        }
    }, [defaultValue, location, hidden]);

    const toggle = useCallback(() => {
        setActive((prev) => !prev);
    }, []);

    const COMMENTS_PERMISSIONS = useCheckPermission({
        scope: "Project",
        domain: "Comments",
    });

    const button = useMemo(() => {
        switch (type) {
            case "comment": {
                const isClosed = !active;
                return (
                    !hidden && (
                        <Tooltip
                            title={t(
                                `common::label::${isClosed ? "Open" : "Close"} comment window`,
                                `${isClosed ? "Open" : "Close"} comment window`,
                            )}
                            placement={"left"}
                        >
                            <IconButton
                                circled
                                variant={"contained"}
                                color={isClosed ? "success" : "greySecondary"}
                                disabled={!COMMENTS_PERMISSIONS.READ}
                                onClick={toggle}
                            >
                                {isClosed ? <IconReply size={16} /> : <IconClose size={16} />}
                            </IconButton>
                        </Tooltip>
                    )
                );
            }
        }
    }, [active, hidden, COMMENTS_PERMISSIONS.READ, t, toggle, type]);

    return {
        toggle: active,
        button,
    };
};

export default useFoldActionButtons;
